import $ from 'jquery';

export const woInterval = (that,obj,dateTimeStr) => {
    try {
        const [datePart, timePart] = dateTimeStr.split(' ');
        const [year, month, day] = datePart.split('-').map(Number);
        const [hours, minutes, seconds] = timePart.split(':').map(Number);
        // 创建目标时间对象
        const targetTime = new Date(year, month - 1, day, hours, minutes, seconds);
        // 验证日期有效性
        if (isNaN(targetTime.getTime())) {
            throw new Error('无效的日期时间');
        }
        // 添加72小时
        targetTime.setTime(targetTime.getTime() + (72 * 60 * 60 * 1000));
        // 获取当前时间
        const now = new Date();
        // 计算时间差（毫秒）
        var diffMs = targetTime - now;
        this.timer = setInterval(() => {
            if(diffMs<1000){
                clearInterval(this.timer);
                that.getData();
            }
            diffMs = diffMs - 1000;
            const absDiffMs = Math.abs(diffMs);
            // 将毫秒转换为小时、分钟、秒
            const totalSeconds = Math.floor(absDiffMs / 1000);
            const hoursDiff = Math.floor(totalSeconds / 3600);
            const minutesDiff = Math.floor((totalSeconds % 3600) / 60);
            const secondsDiff = totalSeconds % 60;
            // 格式化为两位数
            const format = (num) => num.toString().padStart(2, '0');
            $(obj).text(`${format(hoursDiff)}:${format(minutesDiff)}:${format(secondsDiff)}`);
            // 一些重复逻辑
        }, 1000);
    } catch (e) {
        $(obj).text("-");
    }
};

